<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Only2Photos:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <app-block-text
            [maxLength]="500"
            [type]="'link'"
            [blockData]="block.variables?.['FirstImage'] ?? ''"
            (handleOnChange)="onChange($event, 'FirstImage')"
            [placeholder]="firstImagePlaceholder"
            variable="FirstImage"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>

        <div class="col-6">
          <app-block-text
            [maxLength]="500"
            [type]="'link'"
            [blockData]="block.variables?.['SecondImage'] ?? ''"
            (handleOnChange)="onChange($event, 'SecondImage')"
            [placeholder]="secondImagePlaceholder"
            variable="SecondImage"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>

        <div class="col-6">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            [blockData]="block.variables?.['FirstImageHref'] ?? ''"
            (handleOnChange)="onChange($event, 'FirstImageHref')"
            [placeholder]="firstImageHrefPlaceholder"
            variable="FirstImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'FirstImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.FirstImageHrefSegmentRegex ?? ''"
          >
          </app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            [blockData]="block.variables?.['SecondImageHref'] ?? ''"
            (handleOnChange)="onChange($event, 'SecondImageHref')"
            [placeholder]="secondImageHrefPlaceholder"
            variable="SecondImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'SecondImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.SecondImageHrefSegmentRegex ?? ''"
          >
          </app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            [blockData]="block.variables?.['FirstImageAlt'] ?? ''"
            (handleOnChange)="onChange($event, 'FirstImageAlt')"
            [placeholder]="firstImageAltPlaceholder"
            variable="FirstImageAlt"
          >
          </app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            [blockData]="block.variables?.['SecondImageAlt'] ?? ''"
            (handleOnChange)="onChange($event, 'SecondImageAlt')"
            [placeholder]="secondImageAltPlaceholder"
            variable="SecondImageAlt"
          >
          </app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row">
          <div *ngIf="block.variables?.['FirstImage']" class="row col-6">
            <a
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.['FirstImageHref']))"
              target="_blank"
            >
              <img
                [src]="$safeNavigationMigration(block.variables?.['FirstImage'])"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.['FirstImageAlt'])"
              />
            </a>
          </div>

          <div *ngIf="block.variables?.['SecondImage']" class="row col-6">
            <a
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.['SecondImageHref']))"
              target="_blank"
            >
              <img
                [src]="$safeNavigationMigration(block.variables?.['SecondImage'])"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.['SecondImageAlt'])"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
